import styled from 'styled-components';
import { LeftBarStyled } from '../LeftBar/styles';

export const AdmLeftBarStyled = styled(LeftBarStyled)`
  .menuItem.disabled {
    cursor: default;

    .icon {
      opacity: 0.55;
    }

    .titleMenu {
      opacity: 0.55;
    }

    &:hover {
      border-left: 4px solid transparent !important;
      background-color: ${({ theme }) => theme.colors.surface.surface};

      .icon {
        color: ${({ theme }) => theme.colors.surface.onSurface} !important;
      }
    }
  }
`;

export const ComingSoonBadge = styled.span`
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  margin-right: 12px;
  border-radius: 4px;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.surface.onSurface};
  background-color: ${({ theme }) => theme.colors.surface.onSurfaceHover};
`;
